import { render, staticRenderFns } from "./RecommendProductComponent.vue?vue&type=template&id=2230ec14&scoped=true&"
import script from "./RecommendProductComponent.vue?vue&type=script&lang=js&"
export * from "./RecommendProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecommendProductComponent.vue?vue&type=style&index=0&id=2230ec14&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2230ec14",
  null
  
)

export default component.exports